import { useMutation } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import type { ManualProcessOutcome } from "@/types/domain";

/**
 * Sube un archivo corregido a un contractingfile (acción de admin): crea una
 * versión nueva, limpia los ítems de la superada y la reprocesa con IA. Con
 * `asNewPriceRelation` lo suma como otra relación de precios de la misma
 * licitación en vez de reemplazar. Devuelve cómo terminó; el listado NO se
 * invalida para que la fila siga a la vista con su resultado.
 */
export function useUploadCorrectedFile() {
  return useMutation({
    mutationFn: ({
      fileId,
      fileName,
      base64Data,
      asNewPriceRelation,
    }: {
      fileId: number;
      fileName: string;
      base64Data: string;
      asNewPriceRelation?: boolean;
    }) =>
      fetchToBackend<ManualProcessOutcome>(
        "/admin/contractings/upload-manual",
        {
          method: "POST",
          body: JSON.stringify({
            contractingfile_id: fileId,
            fileName,
            base64Data,
            asNewPriceRelation,
          }),
        },
      ),
  });
}
